import {useMemo} from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import {getClassroomsQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import sessionStore from 'client/Session/SessionStore';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useClassrooms() {
  const areClassroomsLoading = useStudentDashboard((state) => state.areClassroomsLoading);
  const classrooms = useStudentDashboard((state) => state.classrooms);
  const setAreClassroomsLoading = useStudentDashboard((state) => state.setAreClassroomsLoading);
  const setClassrooms = useStudentDashboard((state) => state.setClassrooms);
  const studentId = sessionStore.getUserId();

  const query = useMemo(() => getClassroomsQuery(studentId), [studentId]);

  function fetchClassrooms() {
    setAreClassroomsLoading(true);

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((fetchedClassrooms) => {
        setClassrooms(fetchedClassrooms);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      })
      .finally(() => {
        setAreClassroomsLoading(false);
      });
  }

  return {areClassroomsLoading, classrooms, fetchClassrooms};
}
